<div class="header-container">
  <nav>
    <div class="header-left">
      <div class="logo">
        <a [routerLink]="'/'"></a>
      </div>
      <app-navigation />
    </div>

    <app-header-search class="centered-searchbar" />

    <div class="header-right">
      <div class="right-part">
        <mat-icon (click)="openSupportDialog()">contact_support</mat-icon>
        <app-user-info />
      </div>
    </div>
  </nav>
</div>
